import * as Types from '../../../../__generated__/base.gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type WholeSyncableEpocusPatientConsentFragment = { readonly __typename?: 'SyncableEpocusPatientConsent', readonly id: string, readonly encounterId: string, readonly elephantPatientIdentityValue?: string | null, readonly audience: Types.EpocusConsentAudience, readonly kind: Types.EpocusConsentItemKind, readonly response: Types.EpocusConsentResponse, readonly consentDocumentId: string, readonly privacyPolicyId?: string | null, readonly programId?: string | null, readonly meta: { readonly __typename?: 'SyncableMeta', readonly createdAt: string, readonly updatedAt: string, readonly createdByUserId: string, readonly updatedByUserId: string, readonly deleted: boolean } };

export type SyncEpocusPatientConsentPullQueryVariables = Types.Exact<{
  input: Types.PullEpocusPatientConsentInput;
}>;


export type SyncEpocusPatientConsentPullQuery = { readonly __typename?: 'Query', readonly pullEpocusPatientConsent: { readonly __typename?: 'PullEpocusPatientConsentResponse', readonly checkpoint?: { readonly __typename?: 'SyncableCheckpoint', readonly id: string, readonly updatedAt: string } | null, readonly documents: ReadonlyArray<{ readonly __typename?: 'SyncableEpocusPatientConsent', readonly id: string, readonly encounterId: string, readonly elephantPatientIdentityValue?: string | null, readonly audience: Types.EpocusConsentAudience, readonly kind: Types.EpocusConsentItemKind, readonly response: Types.EpocusConsentResponse, readonly consentDocumentId: string, readonly privacyPolicyId?: string | null, readonly programId?: string | null, readonly meta: { readonly __typename?: 'SyncableMeta', readonly createdAt: string, readonly updatedAt: string, readonly createdByUserId: string, readonly updatedByUserId: string, readonly deleted: boolean } }> } };

export type SyncEpocusPatientConsentPushMutationVariables = Types.Exact<{
  input: Types.PushEpocusPatientConsentInput;
}>;


export type SyncEpocusPatientConsentPushMutation = { readonly __typename?: 'Mutation', readonly pushEpocusPatientConsent: { readonly __typename?: 'PushEpocusPatientConsentResult', readonly rows: ReadonlyArray<{ readonly __typename?: 'SyncableEpocusPatientConsent', readonly id: string, readonly encounterId: string, readonly elephantPatientIdentityValue?: string | null, readonly audience: Types.EpocusConsentAudience, readonly kind: Types.EpocusConsentItemKind, readonly response: Types.EpocusConsentResponse, readonly consentDocumentId: string, readonly privacyPolicyId?: string | null, readonly programId?: string | null, readonly meta: { readonly __typename?: 'SyncableMeta', readonly createdAt: string, readonly updatedAt: string, readonly createdByUserId: string, readonly updatedByUserId: string, readonly deleted: boolean } }> } };

export const WholeSyncableEpocusPatientConsentFragmentDoc = gql`
    fragment WholeSyncableEpocusPatientConsent on SyncableEpocusPatientConsent {
  id
  encounterId
  elephantPatientIdentityValue
  audience
  kind
  response
  consentDocumentId
  privacyPolicyId
  programId
  meta {
    createdAt
    updatedAt
    createdByUserId
    updatedByUserId
    deleted
  }
}
    `;
export const SyncEpocusPatientConsentPullDocument = gql`
    query SyncEpocusPatientConsentPull($input: PullEpocusPatientConsentInput!) {
  pullEpocusPatientConsent(input: $input) {
    checkpoint {
      id
      updatedAt
    }
    documents {
      ...WholeSyncableEpocusPatientConsent
    }
  }
}
    ${WholeSyncableEpocusPatientConsentFragmentDoc}`;

/**
 * __useSyncEpocusPatientConsentPullQuery__
 *
 * To run a query within a React component, call `useSyncEpocusPatientConsentPullQuery` and pass it any options that fit your needs.
 * When your component renders, `useSyncEpocusPatientConsentPullQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSyncEpocusPatientConsentPullQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSyncEpocusPatientConsentPullQuery(baseOptions: Apollo.QueryHookOptions<SyncEpocusPatientConsentPullQuery, SyncEpocusPatientConsentPullQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SyncEpocusPatientConsentPullQuery, SyncEpocusPatientConsentPullQueryVariables>(SyncEpocusPatientConsentPullDocument, options);
      }
export function useSyncEpocusPatientConsentPullLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SyncEpocusPatientConsentPullQuery, SyncEpocusPatientConsentPullQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SyncEpocusPatientConsentPullQuery, SyncEpocusPatientConsentPullQueryVariables>(SyncEpocusPatientConsentPullDocument, options);
        }
export type SyncEpocusPatientConsentPullQueryHookResult = ReturnType<typeof useSyncEpocusPatientConsentPullQuery>;
export type SyncEpocusPatientConsentPullLazyQueryHookResult = ReturnType<typeof useSyncEpocusPatientConsentPullLazyQuery>;
export type SyncEpocusPatientConsentPullQueryResult = Apollo.QueryResult<SyncEpocusPatientConsentPullQuery, SyncEpocusPatientConsentPullQueryVariables>;
export const SyncEpocusPatientConsentPushDocument = gql`
    mutation SyncEpocusPatientConsentPush($input: PushEpocusPatientConsentInput!) {
  pushEpocusPatientConsent(input: $input) {
    rows {
      ...WholeSyncableEpocusPatientConsent
    }
  }
}
    ${WholeSyncableEpocusPatientConsentFragmentDoc}`;
export type SyncEpocusPatientConsentPushMutationFn = Apollo.MutationFunction<SyncEpocusPatientConsentPushMutation, SyncEpocusPatientConsentPushMutationVariables>;

/**
 * __useSyncEpocusPatientConsentPushMutation__
 *
 * To run a mutation, you first call `useSyncEpocusPatientConsentPushMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncEpocusPatientConsentPushMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncEpocusPatientConsentPushMutation, { data, loading, error }] = useSyncEpocusPatientConsentPushMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSyncEpocusPatientConsentPushMutation(baseOptions?: Apollo.MutationHookOptions<SyncEpocusPatientConsentPushMutation, SyncEpocusPatientConsentPushMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SyncEpocusPatientConsentPushMutation, SyncEpocusPatientConsentPushMutationVariables>(SyncEpocusPatientConsentPushDocument, options);
      }
export type SyncEpocusPatientConsentPushMutationHookResult = ReturnType<typeof useSyncEpocusPatientConsentPushMutation>;
export type SyncEpocusPatientConsentPushMutationResult = Apollo.MutationResult<SyncEpocusPatientConsentPushMutation>;
export type SyncEpocusPatientConsentPushMutationOptions = Apollo.BaseMutationOptions<SyncEpocusPatientConsentPushMutation, SyncEpocusPatientConsentPushMutationVariables>;